import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  AttendanceSettingsDTO,
  CreateAttendanceSettingsDTO,
  UpdateAttendanceSettingsDTO,
} from '../attendance-settings.types';

@Injectable()
export class AttendanceSettingsDetailFormService {
  constructor(private readonly fb: FormBuilder) {}

  createForm(): FormGroup {
    return this.fb.group({
      enable_auto_close_open_attendance: [false],
      auto_close_time: [
        '',
        [Validators.pattern(/^([01]\d|2[0-3]):([0-5]\d)$/)],
      ],
    });
  }

  populateForm(form: FormGroup, settings: AttendanceSettingsDTO): void {
    form.setValue({
      enable_auto_close_open_attendance:
        settings.enable_auto_close_open_attendance ?? false,
      auto_close_time: settings.auto_close_time ?? '',
    });
  }

  getCreateDTO(form: FormGroup): CreateAttendanceSettingsDTO {
    const value = form.getRawValue();
    return {
      enable_auto_close_open_attendance:
        value.enable_auto_close_open_attendance ?? false,
      auto_close_time: value.auto_close_time?.trim() || null,
    };
  }

  getUpdateDTO(form: FormGroup): UpdateAttendanceSettingsDTO {
    const value = form.getRawValue();
    return {
      enable_auto_close_open_attendance:
        value.enable_auto_close_open_attendance ?? false,
      auto_close_time: value.auto_close_time?.trim() || null,
    };
  }
}
